// extracted by mini-css-extract-plugin
export var textInput = "_h7-0";